import i18next from "i18next";
import {createAsyncThunk, createSelector, createSlice} from "@reduxjs/toolkit";
import httpRequest from "../../services/httpRequest";
import AppUtil from "../../utilities/AppUtil";

const t = i18next.getFixedT();

const _urlPrefix = "/billing";

export const fetchBillingPaging = createAsyncThunk(
    "billing/fetchBillingPaging",
    async (params) => {
        const result = await httpRequest({
            url: `${_urlPrefix}/page`,
            params: AppUtil.toSnakeCaseKey(params),
            method: "GET"
        });
        if (!result) {
            return;
        }
        return result.data;
    }
);

export const fetchBillingDetail = createAsyncThunk(
    "billing/fetchBillingDetail",
    async (params) => {
        const result = await httpRequest({
            url: `${_urlPrefix}/detail/${params}`,
            method: "GET"
        });
        if (!result) {
            return;
        }
        return result.data;
    }
);

export const reduceCreateBilling = createAsyncThunk(
    "billing/reduceCreateBilling",
    async (params) => {
        const result = await httpRequest({
            url: `${_urlPrefix}`,
            method: "POST",
            data: AppUtil.toSnakeCaseKey(params),
            successMessage: 'toast.create.200'
        });
        if (!result) {
            return;
        }
        return result.data;
    }
);

export const reduceInvoiceBilling = createAsyncThunk(
    "billing/reduceInvoiceBilling",
    async (params) => {
        const result = await httpRequest({
            url: `${_urlPrefix}/submit/${params}`,
            method: "PUT",
            successMessage: 'toast.success.invoice'
        });
        if (!result) {
            return;
        }
        return result.data;
    }
);

export const reduceExportBilling = createAsyncThunk(
    "billing/reduceExportBilling",
    async (params) => {
        const result = await httpRequest({
            url: `${_urlPrefix}/export-billing`,
            method: "GET",
            params: AppUtil.toSnakeCaseKey(params),
            successMessage: 'toast.success.export_billing'
        });
        if (!result) {
            return;
        }
        AppUtil.downloadCSV(result, `billing-${new Date().getTime()}`);
        return result.data;
    }
);

const initialState = {
    list: [],
    detail: {},
};

const slice = createSlice({
    name: "billing",
    initialState: initialState,
    reducers: {},
    extraReducers: {
        [fetchBillingPaging.fulfilled]: (state, {payload}) => {
            if (payload) {
                state.list = payload.content;
            }
        },
        [fetchBillingDetail.fulfilled]: (state, {payload}) => {
            if (payload) {
                state.detail = payload;
            }
        }
    },
});

const { reducer } = slice;
// export const {} = actions;
export default reducer;

export const getBillingList = createSelector(
    state => state.billing.list,
    list => list
)
